// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Association_wrapper__1TJe2"};